import { Box, Typography, Button } from '@mui/material';
import React, { useEffect, useState } from 'react'
import { Link, useParams } from 'react-router-dom'
import FetchData from '../../api/FetchData';
import WaitingLoader from '../../components/general/loader/WaitingLoader';

export default function MobileVerification() {

    const { id } = useParams();
    const [msg, setMsg] = useState("");
    const [loading, setLoading] = useState(false);

    const VerifyNumber = () => {
        setLoading(true);
        FetchData.create("/user/verifyMobile", {v: id})
        .then((res) => {
            setMsg(res?.data?.response?.message);
        })
        .catch(() => {

        })
        .finally(() => {
            setLoading(false);
        })
    }

    useEffect(() => {
        VerifyNumber();
        //eslint-disable-next-line
    }, [id]);

    return (
        <Box height={'500px'} width={'90%'} marginX={'auto'} justifyContent={'center'} alignItems={'center'} display={'flex'}>
            {
                loading ? <WaitingLoader open={loading} />
                :
                <Box width={{md: '500px', xs: '80%'}} sx={{ backgroundColor: '#120f2e', padding: '20px', borderRadius: '20px', display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column' }}>
                    <Typography variant="h1" textAlign={'center'} fontSize={{md: '20px', xs: '1rem'}} fontWeight={'bold'} color='#FFF'>
                        {msg}
                    </Typography>
                </Box>
            }
        </Box>
    )
}